import cx from 'classnames';
import {DragEvent, ReactNode, RefObject, useCallback, useState} from 'react';

import './FileDropZone.sass';

interface FileDropZoneProps {
  show?: boolean;
  children?: ReactNode;
  inputRef: RefObject<HTMLInputElement>;
  hasBorder?: boolean;
  disabled?: boolean;
}

export const FileDropZone = ({
  show = false,
  children,
  inputRef,
  hasBorder = false,
  disabled = false,
}: FileDropZoneProps) => {
  const [dragging, setDragging] = useState(false);

  const onDragOver = useCallback((e: DragEvent) => {
    e.preventDefault();
    setDragging(true);
  }, []);

  const onDragLeave = useCallback((e: DragEvent) => {
    e.preventDefault();
    setDragging(false);
  }, []);

  const onDrop = useCallback(
    (e: DragEvent) => {
      e.preventDefault();
      setDragging(false);

      if (!inputRef.current || disabled) return;

      // Build a new file list from dropped files
      const dt = new DataTransfer();
      Array.from(e.dataTransfer.files).forEach((file) => dt.items.add(file));

      // Assign to the input and fire its change event
      inputRef.current.files = dt.files;
      inputRef.current.dispatchEvent(new Event('change', {bubbles: true}));
    },
    [inputRef, disabled]
  );

  if (!show) return children;

  return (
    // biome-ignore lint/a11y/useAriaPropsSupportedByRole: button?
    // biome-ignore lint/a11y/noStaticElementInteractions: button?
    <div
      className={cx('file-dropzone', {
        'file-dropzone--hover': dragging,
        'file-dropzone--has-border': hasBorder,
      })}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      aria-label="File drag-n-drop zone"
    >
      {children}
    </div>
  );
};
